export default "__VITE_ASSET__Bx_YiF1r__"